<div class="terminos-overlay" (click)="aceptar()">
    <div class="terminos-modal" (click)="$event.stopPropagation()">
        <div class="terminos-header">
            <h2>{{Titulo}}</h2>
        </div>
        
        <div class="terminos-body scrollable-content" [innerHTML]="TerminosCondiciones">
        </div>

        <div class="terminos-footer">
            <button class="btn-cerrar-modal" (click)="aceptar()">Cerrar</button>
        </div>
    </div>
</div>
